module.exports = __webpack_public_path__ + "static/media/int_1.5cfd80fd.jpg";